import { render, staticRenderFns } from "./FormEsposa.vue?vue&type=template&id=dfa40766"
import script from "./FormEsposa.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormEsposa.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports